/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Start_DescriptionInputs */

const en_gc_resources_guide_start_description = /** @type {(inputs: Gc_Resources_Guide_Start_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open an XLSX file, edit a few cells and save a copy you can keep.`)
};

const zh_gc_resources_guide_start_description = /** @type {(inputs: Gc_Resources_Guide_Start_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 XLSX 文件，编辑单元格，然后保存一份自己的副本。`)
};

/**
* | output |
* | --- |
* | "Open an XLSX file, edit a few cells and save a copy you can keep." |
*
* @param {Gc_Resources_Guide_Start_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_start_description = /** @type {((inputs?: Gc_Resources_Guide_Start_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Start_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_start_description(inputs)
	return zh_gc_resources_guide_start_description(inputs)
});
export { gc_resources_guide_start_description as "gc.resources.guide.start.description" }